<div class="wrapper">
  <div class="heading text-type-2">Add usage</div>
  <form [formGroup]="form" class="flex flex-col gap-[20px]">
    <app-text-input
      [parentFormGroup]="form"
      controlName="searchText"
      placeholder="Search bid item, material"
      label="USAGE ITEM"
      suffixIcon="search"
      (focusin)="showList = true"
      />

    @if (showList) {
      <div class="materials-list">
        @if (filteredElementsList.length > 0) {
          @for (eachElement of filteredElementsList; track eachElement; let first = $first; let last = $last) {
            <div
              class="each-item flex justify-start items-center gap-[16px]"
              [class.first]="first"
              [class.last]="last"
              (click)="addUsage(eachElement)"
              >
              <div class="flex flex-col justify-center items-start">
                <div class="element-heading text-type-6">{{ eachElement.item || eachElement.name }}</div>
                @if (eachElement.description) {
                  <div
                    class="description text-type-13"
                    >
                    {{ eachElement.description }}
                  </div>
                }
                <div class="uom text-type-14">{{ eachElement.uom }}</div>
              </div>
            </div>
          }
        } @else {
          <div class="no-data">
            No data available.
          </div>
        }
      </div>
    }
  </form>
</div>
